import { Link } from 'react-router-dom';
import './errorpage.css';

function LegacyRedirectPage() {
  return (
    <>
      <div className="container py-5">
        <div style={{ textAlign: 'center', padding: '60px 20px' }}>
          <h2>We’ve upgraded our website</h2>

          <p style={{ marginTop: '20px', fontSize: '16px' }}>
            We have moved to a new upgraded website system. <br />
            Please update your bookmarks in your browser and navigate using the links below.
          </p>

          <div style={{ marginTop: '30px' }}>
            <Link to="/" style={{ marginRight: '20px', fontWeight: 'bold' }}>
              Go to Home Page
            </Link>

            <Link to="/donation" style={{ fontWeight: 'bold' }}>
              Go to Donation Page
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default LegacyRedirectPage;
